require('dotenv').config();

/* eslint-disable max-len */

export const port = process.env.PORT || 3000;
export const host = process.env.WEBSITE_HOSTNAME || `localhost:${port}`;
export const url = process.env.WEBSITE_URL || 'http://localhost:3001';
export const sitename = 'Experiencia Rural';

// default locale is the first one
// La plataforma opera en español; evitar que el navegador seleccione inglés.
export const locales = ['es'];

export const databaseUrl = process.env.DATABASE_URL;

// Listing Photos Upload Directory
export const fileuploadDir = process.env.FILEUPLOAD_DIR || './images/upload/';

// Logo upload directory
export const logouploadDir = process.env.LOGOUPLOAD_DIR || './images/logo/';

// Home page Banner upload directory
export const banneruploadDir = process.env.BANNER_UPLOAD_DIR || './images/banner/';

// User Profile Photos Upload Directory
export const profilePhotouploadDir = process.env.PROFILE_PHOTO_UPLOAD_DIR || './images/avatar/';

//Document Upload
export const documentuploadDir = process.env.FILEUPLOAD_DIR || './images/document/';

// Location upload directory
export const locationuploadDir = process.env.LOGOUPLOAD_DIR || './images/popularLocation/';

// Static block image upload directory
export const homebanneruploadDir = process.env.HOME_BANNER_UPLOAD_DIR || './images/home/';

// Amenities upload directory
export const amenitiesUploadDir = process.env.AMENITIES_UPLOAD_DIR || './images/amenities/';

// Favicon images update directory
export const faviconUploadDir = process.env.FAVICON_UPLOAD_DIR || './images/favicon/';

// whyHostUploadDir
export const whyHostUploadDir = process.env.WHYHOST_UPLOAD_DIR || './images/whyhost/';

export const analytics = {
  google: {
    trackingId: 'UA-XXXXX-X',
  },
};

export const googleMapAPI = '<Your API Key>';
export const googleMapServerAPI = process.env.GOOGLE_MAP_SERVER_API;

export const payment = {
  paypal: {
    returnURL: `${url}${process.env.PAYPAL_RETURN_URL}`,
    cancelURL: `${url}${process.env.PAYPAL_CANCEL_URL}`,
    redirectURL: {
      success: `${url}${process.env.PAYPAL_SUCCESS_REDIRECT_URL}`,
      cancel: `${url}${process.env.PAYPAL_CANCEL_URL}`
    },
  },
  stripe: {
    secretKey: process.env.STRIPE_SECRET,
    publishableKey: 'pk_test_C5ukBJM7qr5P1F8dY4XKhdyp'
  }
};

export const googleCaptcha = {
  sitekey: '<Your Google reCAPCHA Site key>',
};

export const auth = {
  jwt: { secret: process.env.JWT_SECRET },
  redirectURL: {
    login: '/',
    verification: '/user/verification',
    userbanned: '/userbanned',
    returnURLDeletedUser: '/userbanned'
  },
  facebook: {
    returnURL: `${url}/login/facebook/return`,
  },
  google: {
    returnURL: `${url}/login/google/return`,
  }
};
